/* eslint-disable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-return, @typescript-eslint/no-explicit-any */
import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core'
import { FormControl } from '@angular/forms'
import { Observable, finalize, takeUntil } from 'rxjs'

import { DestroyService } from '@app/core/services/destroy.service'
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete'

@Component({
  selector: 'lin-table-cell-autocomplete-select',
  templateUrl: './table-cell-autocomplete-select.component.html',
  styleUrls: ['./table-cell-autocomplete-select.component.scss'],
  providers: [DestroyService],
  standalone: false,
})
export class TableCellAutocompleteSelectComponent implements AfterViewInit {
  control = new FormControl('')

  autocompleteOptions = []
  isAutocompleteLoading = false
  optionsInitialized = false

  @Input() inputValue: string
  @Input() placeholder: string
  @Input() hasEmptyOption = false
  @Input() emptyOptionLabel: string

  @Input() autocompleteRequest: (value: string) => Observable<any>
  @Input() displayWith: (value: any) => string

  @Output() valueSelected = new EventEmitter<any>()

  @ViewChild('inputElement', { static: true }) inputElement: ElementRef<HTMLInputElement>

  constructor(private readonly destroyService: DestroyService) {}

  ngAfterViewInit(): void {
    this.initControlHandler()
  }

  handleSelectValue(event: MatAutocompleteSelectedEvent): void {
    this.setValue(this.displayWith(event.option.value))
    this.valueSelected.emit(event)
  }

  initOptionsList(): void {
    if (this.optionsInitialized) return

    this.triggerSearch(<string>this.control.value)
    this.optionsInitialized = true
  }

  private initControlHandler(): void {
    this.inputValue && this.setValue(this.inputValue)

    this.control.valueChanges.pipe(takeUntil(this.destroyService)).subscribe((value: string) => {
      this.optionsInitialized = false
      this.triggerSearch(value)
    })
  }

  private triggerSearch(value: string): void {
    this.isAutocompleteLoading = true

    this.autocompleteRequest(value)
      .pipe(
        finalize(() => (this.isAutocompleteLoading = false)),
        takeUntil(this.destroyService),
      )
      .subscribe((autocompleteOptions) => (this.autocompleteOptions = autocompleteOptions))
  }

  private setValue(value: string): void {
    this.control.setValue(value)
    setTimeout(() => {
      this.inputElement.nativeElement.value = value
    })
  }
}
